import { AssignmentTurnedInOutlined, EditOutlined } from "@mui/icons-material";
import { Box, IconButton, Stack, SxProps, Typography } from "@mui/material";
import { useState } from "react";
import { ContextPathBreadcrumbs, EditContextModal } from "src/components";
import { ActionItemDetailDto, ActionItemSummaryDto, useEditActionItemContext } from "src/http";

interface IProps {
  actionItem: ActionItemDetailDto | ActionItemSummaryDto;
  isEditable: boolean;
  sx?: SxProps;
}

const ActionItemContextProperty = (props: IProps) => {
  const { context } = props.actionItem;
  const [isEditModalVisible, setIsEditModalVisible] = useState<boolean>(false);
  const { mutate: editActionItemContext } = useEditActionItemContext();

  async function handleContextChanged(
    contextActionItemGuid: string | null,
    currentContextActionItemGuid: string | null
  ) {
    await editActionItemContext({
      actionItemGuid: props.actionItem.guid,
      contextActionItemGuid: contextActionItemGuid,
      currentContextActionItemGuid: currentContextActionItemGuid,
      planGuid: props.actionItem.teamPlanSection.planGuid,
    });
    setIsEditModalVisible(false);
  }

  return (
    <>
      <Stack direction="row" spacing={0.25} sx={{ alignItems: "center", ...props.sx }}>
        <AssignmentTurnedInOutlined />
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          {context == null ? (
            <Typography variant="placeholder">Connect to Context</Typography>
          ) : (
            <ContextPathBreadcrumbs contextPath={context} linksOpenDrawer />
          )}
        </Box>

        {props.isEditable && (
          <IconButton size="small" sx={{ color: "rgba(0, 0, 0, 0.3)" }} onClick={() => setIsEditModalVisible(true)}>
            <EditOutlined />
          </IconButton>
        )}
      </Stack>

      {props.isEditable && (
        <EditContextModal
          open={isEditModalVisible}
          actionItemGuid={props.actionItem.guid}
          context={props.actionItem.context}
          onUpdateClicked={handleContextChanged}
          onCancelled={() => setIsEditModalVisible(false)}
        />
      )}
    </>
  );
};

export { ActionItemContextProperty };
